import { useState } from 'react'
import { useSelector } from 'react-redux'
import supportIcon from '../../../assests/icons/supportIcon.png'
import BackdropPopup from '../../ui/backdropPopup/BackdropPopup'
import bubble from '../../../assests/icons/bubble.png'
import classes from './Support.module.css'

const Support = () => {

    const [showPopup, setShowPopup] = useState()
    const { texts } = useSelector(state => state.translate);
    const { isStudent } = useSelector(state => state.auth);

    const openSupportHandle = () => {
        const myLink = isStudent ? window.config.supportLinkStudent : window.config.supportLinkTeacher
        if (myLink)
            window.open(myLink, '_blank');
    }

    return (
        <>
            <div className={classes.SupportIconWrapper} onClick={() => setShowPopup(true)}>
                <img className={classes.SupportIcon} src={supportIcon} alt="support"/>
                <div className={classes.IconText}>{texts.supportText}</div>
            </div>
            {showPopup &&
                <BackdropPopup dropClass={classes.SupportDropClass} close={() => setShowPopup(false)}>
                    <img className={classes.Bubble} src={bubble} alt='' />
                    <div className={classes.Text}>
                        <p className={classes.Title}>{texts.supportTitle}</p>
                        <div className={classes.SupportNumber}>
                            {texts.SupportNumber?.toString()?.split('')?.map((digit, index) => (
                                <div key={index} className={classes.NumberWrapper}>
                                    {digit}
                                </div>
                            ))}
                        </div>
                        <p className={classes.Description}>{texts.extension}</p>
                        <hr className={classes.Line} />
                        <p className={classes.OpenSupport} onClick={openSupportHandle}>{texts.openSupport}</p>
                    </div>
                </BackdropPopup>
            }
        </>
    )
}

export default Support